import { render, staticRenderFns } from "./menuCategorias.vue?vue&type=template&id=52ead178&scoped=true&"
import script from "./menuCategorias.vue?vue&type=script&lang=js&"
export * from "./menuCategorias.vue?vue&type=script&lang=js&"
import style0 from "./menuCategorias.vue?vue&type=style&index=0&id=52ead178&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ead178",
  null
  
)

export default component.exports